export const SEARCH_DEBOUNCE_TIME = 400; // milliseconds
export const AUTOCOMPLETE_DEBOUNCE_TIME = 300; // milliseconds
